// test2382
(2382 && 0);
